import axiosInstance from "./axiosInstance";

export const updateWasteStat = (imageName, params) => {
  return axiosInstance.post(`updateWasteStat/${imageName}`, params);
};
